import { CardAction, ChickletHoverActions } from '../../constants/BehaviorTypes';
import { FlywheelContactCardActionWrapper } from '../../behaviors/flywheel/contact/FlywheelContactCardActionWrapper';
import { getFlywheelContactChickletHoverActions } from '../../behaviors/flywheel/contact/getFlywheelContactChickletHoverActions';
export const Contact = {
  [CardAction]: FlywheelContactCardActionWrapper,
  [ChickletHoverActions]: getFlywheelContactChickletHoverActions
};